<template>
    <div class="relay-description-cell">{{ row.description }}</div>
</template>

<script>
export default {
    components: {},

    props: {
        row: {
            type: Object,
            required: true,
        },
    },
}
</script>

<style>
.relay-description-cell {
    max-width: 300px;
    overflow: auto;
}
</style>
